import { Megaphone } from 'lucide-react'

import { isDemoPresentation } from '@/lib/constants'

import { cn } from '@/utils/ui/styles'

import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from '@/components/ui/sidebar'

import { useBetaAnnouncementPostHog } from '../hooks/use-beta-posthog'
import { useInInvestigationsBeta } from '../hooks/use-in-investigations-beta'
import { useBetaAcknowledged, useBetaAnnouncementActions } from '../store'

/**
 * Standalone "What's New" button shown in the sidebar footer for
 * tenants in the Case Investigations beta. Opens the global announcement dialog
 * and glows for attention until acknowledged.
 */
export function WhatsNewSidebarButton() {
	const inBeta = useInInvestigationsBeta()

	const { open } = useBetaAnnouncementActions()
	const { trackOpened } = useBetaAnnouncementPostHog()
	const acknowledged = useBetaAcknowledged()

	if (!inBeta) return null

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<SidebarMenuButton
					tooltip="What's New"
					onClick={() => {
						trackOpened({ source: 'sidebar' })
						open()
					}}
				>
					{/* Brand "beta glow": pulses for attention until the user clicks
					    "Got it" (persisted `acknowledged`), then sits calm — mirrors
					    TourTrigger's `!seen` gate so the two beta cues behave alike. */}
					<span
						className={cn('text-sidebar-primary relative inline-flex', {
							'beta-ripple': !acknowledged && !isDemoPresentation,
						})}
					>
						<Megaphone />
					</span>
					<span>What's New</span>
				</SidebarMenuButton>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}
